var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Notice of Leave"}}),_c('ContentRow',[_c('ContentContainer',[_c('SectionTitle',[_vm._v("Notice of Leave")]),(_vm.formData)?_c('Form',{attrs:{"context":_vm.formData,"type":"Generic.AU.QLD.Form13Graphical"}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }